import axios from 'axios';
axios.defaults.withCredentials = true;

export const fetchSession = async () => {
  const response = await axios.get('/user/session');
  return response.data;
}

export const login = async (username: string, password: string) => {
  const response = await axios.post('/user/login', { username, password });
  return response.data;
}

export const logout = async () => {
  const { data: response } = await axios.delete('/user/logout');
  if (!response.success) {
    throw new Error("Error in fetching all stats")
  }
  return response.data;
}